<ng-container *ngIf="!loading">
  <div class="page-wrapper bg-gra-01 p-t-45 p-b-50">
      <div class="wrapper wrapper--w790">
          <div class="card card-5">
              <!-- Error message -->
              <div class="alert" *ngIf="serverErrorMessages">
                {{serverErrorMessages}}
            </div>
              <div class="card-heading">
                  <h2 class="title">Welcome</h2>
                  <br>
                  <h2 class="title">Set your Password</h2>
              </div>
                      <form [formGroup]="form" (ngSubmit)="onSubmit()">
                          <div class="card-body">
                              <!-- form start-->
                              <div class="form-row">
                                <div class="col-10">
                                    <div class="value">

                                          <div class="name">USER NAME</div>
                                            <div class="input-group">
                                                <input class="input--style-5"
                                                type="text" formControlName = "userName" style="border-radius: 15px;"
                                                appBlockCopyPaste>

                                                <mat-error *ngIf="form.controls['userName'].invalid && form.controls['userName'].errors.required">Username is required</mat-error>
                                            </div>
                                      </div>
                                </div>
                                <!-- old pass done-->
                                 <div class="col-10">
                                        <div class="value">
                                            <div class="name">DEFAULT PASSWORD</div>
                                            <div class="input-group">
                                                <input class="input--style-5"
                                                      type="password" formControlName="oldPassword" style="border-radius: 15px;"
                                                      appBlockCopyPaste>

                                                <mat-error *ngIf="form.controls['oldPassword'].invalid && form.controls['oldPassword'].errors.required">Default Password is required</mat-error>
                                            </div>
                                        </div>
                                    </div>
                                  <!-- password done -->
                                  <div class="col-10" >
                                    <div class="value">
                                        <div class="name">NEW PASSWORD</div>
                                        <div class="input-group">
                                            <input class="input--style-5"
                                                  type="password" formControlName="newPassword" style="border-radius: 15px;"
                                                  appBlockCopyPaste>

                                            <mat-error *ngIf="form.controls['newPassword'].invalid && form.controls['newPassword'].errors.required">New Password is required</mat-error>

                                            <mat-error *ngIf="form.get('oldPassword').value === form.get('newPassword').value">Passwords must not match</mat-error>
                                        </div>
                                    </div>
                                </div>

                            </div>

                              <!-- form end-->

                              <div>
                                  <button type="submit" class="btn btn-primary" style="padding: 15px;">Submit</button>
                                  <br>
                                  <a href="/home"><button type="button" class="btn btn-primary" style="padding: 15px;">Cancel</button></a>

                                  <br/>
                              </div>
                          </div>
                      </form>

          </div>
      </div>
  </div>
</ng-container>
